import { createSlice } from '@reduxjs/toolkit';
import reducer from './reducer';

const initialState = {
  list: [],
  log: {},
  jobExecutions: [],
  viewItem: undefined,
  logFilter: {
    keyword: '',
    logLevels: [],
    autoRefresh: false,
    refreshInterval: 30,
  },
};

export default createSlice({
  name: 'selects',
  initialState: initialState,
  reducers: reducer,
});
